import { Trans } from '@lingui/macro';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { ListColumn } from 'src/components/lists/ListColumn';
import { ListHeaderWrapper } from 'src/components/lists/ListHeaderWrapper';
import { ListWrapper } from 'src/components/lists/ListWrapper';
import { IsolatedReserve } from 'src/store/v3MigrationSelectors';

import { MigrationIsolationWarning } from './MigrationIsolationWarning';
import { MigrationSelectionBox } from './MigrationSelectionBox';

interface MigrationMobileListProps {
  titleComponent: ReactNode;
  children: ReactNode;
  onSelectAllClick: () => void;
  loading?: boolean;
  isAvailable: boolean;
  emodeCategoryId?: number;
  allSelected: boolean;
  numSelected: number;
  numAvailable: number;
  disabled: boolean;
  isolatedReserveV3?: IsolatedReserve;
}

export const MigrationMobileList = ({
  titleComponent,
  children,
  onSelectAllClick,
  loading,
  isAvailable,
  allSelected,
  numSelected,
  numAvailable,
  disabled,
  isolatedReserveV3,
}: MigrationMobileListProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <ListWrapper
        // Nested inside MigrationLists' outer card — strip this inner surface (matches the desktop
        // MigrationList) so there's no card-in-card. The card variant has no border, so only the
        // shadow needs cancelling.
        paperSx={{ boxShadow: 'none' }}
        titleComponent={
          <Box>
            <Typography component="div" variant="h3" sx={{ mr: 4 }}>
              {titleComponent}
            </Typography>
            <MigrationIsolationWarning isolatedReserveV3={isolatedReserveV3} />
          </Box>
        }
      >
        {(isAvailable || loading) && (
          <ListHeaderWrapper sx={{ pl: 0 }}>
            <ListColumn maxWidth={48} minWidth={48}>
              <MigrationSelectionBox
                allSelected={allSelected}
                numSelected={numSelected}
                onSelectAllClick={onSelectAllClick}
                disabled={disabled}
              />
            </ListColumn>

            <Box
              sx={{
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="subheader2" color="fg-3">
                <Trans>
                  {numSelected}/{numAvailable} assets selected
                </Trans>
              </Typography>
            </Box>
          </ListHeaderWrapper>
        )}

        {children}
      </ListWrapper>
    </Box>
  );
};
